import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const SubscriptionCancelPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Check if user came from Stripe checkout
    const referrer = document.referrer;
    const isFromStripe = referrer.includes('stripe.com') || referrer.includes('checkout.stripe.com');
    
    if (!isFromStripe) {
      // If not from Stripe, redirect to home
      navigate('/');
      return;
    }
  }, [navigate]);

  const handleTryAgain = () => {
    navigate('/');
  };

  const handleGoToShelf = () => {
    navigate('/shelf');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-purple-50 to-blue-50">
      <div className="bg-white rounded-2xl p-8 max-w-md w-full mx-4 shadow-xl border border-purple-100/30 text-center space-y-6">
        {/* Icon */}
        <div className="w-16 h-16 mx-auto text-gray-400">
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
          </svg>
        </div>

        {/* Content */}
        <div className="space-y-3">
          <h3 className="text-2xl font-medium text-gray-900 font-fraunces">
            Subscription Cancelled
          </h3>
          <p className="text-gray-600 font-space">
            No worries! You can still enjoy our free recommendations. You can upgrade to PRO anytime to unlock unlimited access.
          </p>
          
          <div className="bg-gradient-to-r from-purple-50 to-blue-50 rounded-xl p-4 space-y-2">
            <h4 className="font-semibold text-gray-900 font-space">Free features you can still use:</h4>
            <ul className="text-sm text-gray-700 font-space space-y-1">
              <li>• 3 similar book recommendations per day</li>
              <li>• 25 mood-based recommendations per day</li>
              <li>• Save books to your shelf</li>
              <li>• Access to popular books</li>
            </ul>
          </div>
        </div>

        {/* Buttons */}
        <div className="space-y-3">
          <button
            onClick={handleTryAgain}
            className="w-full px-6 py-3 bg-gradient-to-r from-purple-600 to-blue-600 text-white font-semibold rounded-xl hover:from-purple-700 hover:to-blue-700 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105 font-space"
          >
            Try Again
          </button>
          
          <button
            onClick={handleGoToShelf}
            className="w-full px-6 py-2 text-gray-500 text-sm hover:text-gray-700 transition-colors font-space"
          >
            Go to My Shelf
          </button>
        </div>

        {/* Additional Info */}
        <p className="text-xs text-gray-500 font-space">
          Questions about PRO? Contact us at hello@moodshelf.io
        </p>
      </div>
    </div>
  );
};

export default SubscriptionCancelPage; 